import React from "react";
import Navbar from "../../components/Navbar";
import {
  useGetAssignmentMarksQuery,
  useUpdateAssignmentMarkMutation,
} from "../../features/assignmentMark/assignmentMarkApi";

const AssignmentMark = () => {
  const [mark, setMark] = React.useState(0);
  const { data, isLoading } = useGetAssignmentMarksQuery();
  const pending = data?.filter((item) => item.status === "pending");
  const [updateAssignmentMark, { isLoading: isUpdating }] =
    useUpdateAssignmentMarkMutation();

  const handleMarkSent = (item) => {
    const data = {
      id: item.id,
      status: "published",
      mark: parseInt(mark),
    };
    updateAssignmentMark(data);
  };
  if (isLoading || isUpdating) return <div>Loading...</div>;
  return (
    <>
      <Navbar />
      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-7xl px-5 lg:px-0">
          <div className="px-3 py-20 bg-opacity-10">
            <ul className="assignment-status">
              <li>
                Total <span>{data.length}</span>
              </li>
              <li>
                Pending <span>{pending.length}</span>
              </li>
              <li>
                Mark Sent <span>{data.length - pending.length}</span>
              </li>
            </ul>
            <div className="overflow-x-auto mt-4">
              <table className="divide-y-1 text-base divide-gray-600 w-full">
                <thead>
                  <tr>
                    <th className="table-th">Assignment</th>
                    <th className="table-th">Date</th>
                    <th className="table-th">Student Name</th>
                    <th className="table-th">Repo Link</th>
                    <th className="table-th">Mark</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-600/50">
                  {data?.map((item) => (
                    <tr key={item.id}>
                      <td className="table-td">{item.title}</td>
                      {/* <td className="table-td">10 Mar 2023 10:58:13 PM</td> */}
                      <td className="table-td">{item.createdAt}</td>
                      <td className="table-td">{item.student_name}</td>
                      <td className="table-td">{item.repo_link}</td>

                      {item.status === "pending" ? (
                        <td className="table-td input-mark">
                          <input
                            max={item.totalMark}
                            defaultValue={item.totalMark}
                            type="number"
                            onChange={(e) => setMark(e.target.value)}
                          />
                          <span onClick={(e) => handleMarkSent(item)}>
                            <svg
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth={2}
                              stroke="currentColor"
                              className="w-6 h-6 text-green-500 cursor-pointer hover:text-green-400"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M4.5 12.75l6 6 9-13.5"
                              />
                            </svg>
                          </span>
                        </td>
                      ) : (
                        <td className="table-td">{item.mark}</td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AssignmentMark;
